module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"Eventi","pageMetaDescription":"Gestisci gli eventi","location":"Location","eventDate":"Data evento"}}')
  delete Component.options._Ctor
}
